<template >
<div >
  <transition name='fade' mode='out-in' >
    <v-card flat key='client' v-if='appointment && appointment.id' >
      <v-list three-line dense >
        <appointment-list-item with-status-chips
          :with-color-coding='false'
          :appointment='appointment' >
          <v-list-tile-action slot='actions' >
            <appointment-action-menu :appointment='appointment' >
            </appointment-action-menu >
          </v-list-tile-action>
          <v-btn @click='$emit("close")' slot='action' icon >
            <v-icon>close</v-icon>
          </v-btn>
        </appointment-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-tabs v-model='activeTab' dark grow >
        <v-tab v-if='client' >
          <v-icon small class='mr-1' >person</v-icon>
          Client </v-tab>
        <v-tab v-if='appointment' >
          <v-icon small class='mr-1' >event</v-icon>
          Appointment </v-tab>
        <v-tabs-items v-model='activeTab' >
          <v-tab-item v-if='client' >
            <client-details
              :value='client'
              :with-title='false'
              :is-compact='true'
              with-fetch >
            </client-details>
          </v-tab-item>
          <v-tab-item >
            <appointment-card fetch v-model='appointment' />
            <!-- <pre v-text='appointment' /> -->
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </v-card>
    <welcome v-else
      key='home'
      @chart:appointments:clicked='bubble'
      v-model='homepage'
      :loading='loading' >
    </welcome>
  </transition>
</div>
</template>
<script>
import AppointmentActionMenu from '@/components/appointment/actions/ActionMenu'
import AppointmentListItem from '@/components/appointment/AppointmentListItem'
import AppointmentCard from '@/components/cards/AppointmentCard'
import ClientDetails from '@/components/client/ClientDetails'
import Welcome from '@/components/home/Welcome'

export default {
  name: 'HomeDetail',
  components: { ClientDetails,
    AppointmentListItem,
    AppointmentCard,
    AppointmentActionMenu,
    Welcome
  },
  props: {
    appointment: { type: Object, required: false },
    homepage: { type: Object, required: true },
    loading: { type: Boolean, default: false }
  },
  data () {
    return {activeTab: 0}
  },
  computed: {
    client () {
      let vm = this
      return this.$store.getters.clients.find((client) => {
        let clientId = vm.getObjectPath(client, 'client.id')
        if (clientId && vm.appointment.client) {
          return (clientId.toString() === vm.appointment.client.toString())
        }
        // else {
        //   console.log(client)
        // }
      })
    }
  },
  methods: {
    bubble (data) {
      this.$emit('chart:appointments:clicked', data)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Detail.vue?c1c712f0